import styled from 'styled-components'

export const Label = styled.label`
  margin-bottom: 0.375rem;
  font-weight: 500;
  display: inline-block;
`

export const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
`

export const InputRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
`

export const Options = styled.div`
  width: 100%;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-start;
  gap: 10px;
`
